import { mutatorAction } from "satcheljs";
import { bizchatSidepaneStore } from "../store/store";

export const setIsPrecacheCompleteMutator: () => void = mutatorAction("setIsPrecacheComplete", () => {
    bizchatSidepaneStore().isPrecacheComplete = true;
});
